module.exports = __webpack_public_path__ + "static/media/loveShake.826a639d.png";